import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M8.2959 16.8859L12.8759 12.2959L8.2959 7.7059L9.7059 6.2959L15.7059 12.2959L9.7059 18.2959L8.2959 16.8859Z" fill="#00011B"/>
</svg>
;
